/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gt_Get_StartedInputs */

const en_gt_get_started = /** @type {(inputs: Gt_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started`)
};

const ar_gt_get_started = /** @type {(inputs: Gt_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابدأ الآن`)
};

const bn_gt_get_started = /** @type {(inputs: Gt_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শুরু করুন`)
};

const de_gt_get_started = /** @type {(inputs: Gt_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erste Schritte`)
};

const es_gt_get_started = /** @type {(inputs: Gt_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar`)
};

const fr_gt_get_started = /** @type {(inputs: Gt_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer`)
};

const pt_gt_get_started = /** @type {(inputs: Gt_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primeiros passos`)
};

const zh_gt_get_started = /** @type {(inputs: Gt_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始`)
};

const tr_gt_get_started = /** @type {(inputs: Gt_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlayın`)
};

const ru_gt_get_started = /** @type {(inputs: Gt_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начало работы`)
};

const pl_gt_get_started = /** @type {(inputs: Gt_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpocznij`)
};

/**
* | output |
* | --- |
* | "Get Started" |
*
* @param {Gt_Get_StartedInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const gt_get_started = /** @type {((inputs?: Gt_Get_StartedInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gt_Get_StartedInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_gt_get_started(inputs)
	if (locale === "bn") return bn_gt_get_started(inputs)
	if (locale === "de") return de_gt_get_started(inputs)
	if (locale === "es") return es_gt_get_started(inputs)
	if (locale === "fr") return fr_gt_get_started(inputs)
	if (locale === "pt") return pt_gt_get_started(inputs)
	if (locale === "zh") return zh_gt_get_started(inputs)
	if (locale === "tr") return tr_gt_get_started(inputs)
	if (locale === "ru") return ru_gt_get_started(inputs)
	if (locale === "pl") return pl_gt_get_started(inputs)
	return en_gt_get_started(inputs)
});